/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'get': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M674.873 651.32c9.557 8.876 11.719 19.172 6.542 30.778a27.648 27.648 0 01-27.363 17.806H477.127l93.127 212.48a26.852 26.852 0 010 21.902 29.525 29.525 0 01-15.758 15.588l-82.034 33.564a29.753 29.753 0 01-22.755 0 29.582 29.582 0 01-16.157-15.246l-88.462-201.785L200.761 905.9a29.24 29.24 0 01-31.972 6.2c-12.288-5.12-18.432-13.823-18.432-26.396V214.3c0-12.515 6.144-21.276 18.432-26.396a29.412 29.412 0 0131.972 6.2l474.112 457.217zm40.96-491.348h165.945v64.056H715.833V384H649.5V224.028H483.556v-64.056H649.5V0h66.333v159.972z"/>'
  }
})
